import React, { useEffect, useState } from 'react';
import { IconName } from 'react-frontier';
import classNames from 'classnames';

export interface AccordionItemProps{
	onSelected?: ()=>void,
	title: string | JSX.Element,
	rightTitle?: string | JSX.Element,
	children?: JSX.Element | string,
	active?: boolean,
	grayed?: boolean,
	_iconActive?: IconName,
	_iconInactive?: IconName,
	_toggle?: string,
	value?: number,
	bold?: boolean,
	className?: string,
}
var AccordionItem : React.FC<AccordionItemProps> = (props: AccordionItemProps)=>{
	return <div className={classNames('item', { toggle: props._toggle }, props.className, {
		active: props.active,
		disabled: props.grayed,
	})}>
		<div className="header" onClick={props.onSelected} style={{ fontWeight: props.bold ? 'bold' : 'normal' }}>
			<div className="left">{props.title}</div>
			{props.rightTitle ? (
				<div className="right">{props.rightTitle}</div>
			) : null}
		</div>
		{props.active && props.children ? (
			<div className="content">
				{props.children}
			</div>
		) : null}
	</div>
}

type AccordionSubComponents = {
	Item: typeof AccordionItem
}

interface AccordionProps{
	selected: number,
	children: React.ReactNode | string,
	className?: string,
	managed?: boolean,
	selectable?: boolean,
	striped?: boolean,
	divided?: boolean,
	active?: number,
	toggle?: boolean,
	style?: React.CSSProperties,
	greyout?: boolean,
	canUnselect?: boolean
	onSelected?: (value: number)=>void,
}

const Accordion : React.FC<AccordionProps> & AccordionSubComponents = (props)=>{
	var onSelected = (value: number, originalFn: ()=>void)=>{
		return ()=>{
			if(originalFn) originalFn();
			if(props.selected===value){
				if(props.onSelected) props.onSelected(props.canUnselect===false ? value : null);
			}else{
				if(props.onSelected) props.onSelected(value);
			}
		}
	}

	var activeItem = props.selected;
	var childs = (Array.isArray(props.children) ? props.children : [props.children]).flat().map((a,i)=>{
		if(React.isValidElement(a)){
			var value = ((a.props as any)?.value || i);
			var item_props = { 
				value,
				_toggle: props.toggle,
				grayed: (a.props as any).grayed,
				onSelected: onSelected(value, (a.props as any)?.onSelected),
			} as unknown
			if(props.managed!==false){
				(item_props as any).active = activeItem==value;
				(item_props as any).grayed = props.greyout!==false && activeItem!=value && activeItem!==null;
			}
			return React.cloneElement(a, item_props)
		}
	});

	return (
		<div className={classNames('fr accordion', {
			selectable: props.selectable,
			divided: props.divided,
			striped: props.striped,
			toggle: props.toggle,
		})} style={props.style}>
			{childs}
		</div>
	)
}

Accordion.Item = AccordionItem;

export default Accordion;